import router from '@/router'
/**
 * @param {string | object} url
 */
export default function(url, isOpen = true) {
  if (isOpen) {
    // 打开新窗口
    const { href } = router.resolve(url)
    href && window.open(href)
  } else {
    // 更新当前窗口
    router.push(url)
  }
}
